import { Spinner } from "@material-tailwind/react";

export function LoadingPage(_status: boolean) {
    return (
        <div className="flex justify-center items-center">{<Spinner color="orange" className="h-20 w-20" />}</div>
    )
} 